import React, { useEffect } from "react"
import styled from "styled-components"
import text from "styles/text" // Assuming text styles are defined in this file
import media from "styles/media"
import colors from "styles/colors"

export default function richTextRenderer(htmlString, gap) {
  if (typeof window !== "undefined") {
    const tempDiv = document.createElement("div")

    tempDiv.innerHTML = htmlString

    const richContent = Array.from(tempDiv.childNodes).flatMap(
      (node, index) => {
        switch (node.nodeType) {
          case Node.ELEMENT_NODE:
            const Component = styledComponent(node.nodeName)
            return (
              <Component key={index}>
                {richTextRenderer(node.innerHTML)}
              </Component>
            )
          case Node.TEXT_NODE:
            return node.nodeValue
          default:
            return null
        }
      }
    )
    return richContent
  }
}

function styledComponent(tagName) {
  switch (tagName.toUpperCase()) {
    case "STRONG":
      return Strong
    case "EM":
      return Em
    case "H1":
      return H1
    case "H2":
      return H2
    case "H3":
      return H3
    case "H4":
      return H4
    case "H5":
      return H5
    case "H6":
      return H6
    case "UL":
      return UL
    case "OL":
      return OL
    case "LI":
      return LI
    default:
      return P
  }
}

const P = styled.div.attrs(props => ({}))`
  ${text.bodyMd};
`

const Strong = styled.strong.attrs(props => ({}))`
  ${text.bodyMdBold};
`

const Em = styled.em.attrs(props => ({}))`
  ${text.bodyMdBold};
`

const H1 = styled.h1.attrs(props => ({}))`
  ${text.h1};
  ${media.mobile} {
    ${text.h1}
  }
`

const H2 = styled.h2.attrs(props => ({}))`
  ${text.h2};

  ${media.mobile} {
    ${text.h2};
  }
`

const H3 = styled.h3.attrs(props => ({}))`
  ${text.h3};
  ${media.mobile} {
    ${text.h3};
  }
`

const H4 = styled.h4.attrs(props => ({}))`
  ${text.h4};
  ${media.mobile} {
    ${text.h4};
  }
`

const H5 = styled.h5.attrs(props => ({}))`
  ${text.h5};
  ${media.mobile} {
    ${text.h4};
  }
`

const H6 = styled.h6.attrs(props => ({}))`
  ${text.mdBold};
`

const UL = styled.ul.attrs(props => ({}))`
  ${text.bodyMd};
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: unset !important;
  & li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.347vw;
    ${media.fullWidth} {
      margin-bottom: 5px;
    }

    ${media.tablet} {
      margin-bottom: 1.199vw;
    }

    ${media.mobile} {
      margin-bottom: 1.333vw;
    }
  }
  & li::before {
    content: url("data:image/svg+xml;utf8,<svg viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0ZM18.0003 32.4C10.0474 32.4 3.60026 25.9529 3.60026 18C3.60026 10.0471 10.0474 3.59998 18.0003 3.59998C25.9532 3.59998 32.4003 10.0471 32.4003 18C32.4003 21.8191 30.8831 25.4818 28.1826 28.1823C25.4821 30.8828 21.8194 32.4 18.0003 32.4ZM24.8752 11.6821C24.5253 11.3391 23.9652 11.3391 23.6152 11.6821L15.0832 20.2141L12.3832 17.5321C12.2199 17.3581 11.9919 17.2594 11.7532 17.2594C11.5146 17.2594 11.2865 17.3581 11.1232 17.5321L10.1692 18.4861C9.99883 18.6551 9.90299 18.8851 9.90299 19.1251C9.90299 19.3651 9.99883 19.5951 10.1692 19.7641L14.3992 24.0301C14.5625 24.2041 14.7906 24.3028 15.0292 24.3028C15.2679 24.3028 15.4959 24.2041 15.6592 24.0301L25.7752 13.9141C25.9456 13.7451 26.0414 13.5151 26.0414 13.2751C26.0414 13.0351 25.9456 12.8051 25.7752 12.6361L24.8752 11.6821Z' fill='${encodeURIComponent(
      colors.primaryOrange
    )}'/></svg>");
    ${text.bodyMdBold};
    color: ${colors.primaryOrange};
    position: relative;
    width: 5em;
    display: inline-block;
    margin-right: 2.133vw;
    margin-top: 1.067vw;
    ${media.fullWidth} {
      margin-right: 8px;
      margin-top: 4px;
    }

    ${media.tablet} {
      margin-right: 0.959vw;
      margin-top: 0.48vw;
    }

    ${media.mobile} {
      margin-right: 2.133vw;
      margin-top: 1.067vw;
      width: 7em;
    }
  }
`

const OL = styled.ol.attrs(props => ({}))`
  ${text.bodyMd};
  list-style-type: none;
  counter-reset: my-counter;
  & li {
    display: flex;
    align-items: flex-start;
    counter-increment: my-counter;
    margin-bottom: 0.347vw;
  }
  & li:before {
    content: counter(my-counter);
    ${text.bodyMdBold}
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.primaryOrange};
    width: 2.5vw;
    height: 2.5vw;
    border: 0.278vw solid ${colors.primaryOrange};
    border-radius: 3.472vw;
    padding: 0.833vw;
    margin-right: 0.556vw;
    margin-top: 0.278vw;
    ${media.fullWidth} {
      width: 36px;
      height: 36px;
      border: 4px solid ${colors.primaryOrange};
      border-radius: 50px;
      padding: 12px;
      margin-right: 8px;
      margin-top: 4px;
    }

    ${media.tablet} {
      width: 4.317vw;
      height: 4.317vw;
      border: 0.48vw solid ${colors.primaryOrange};
      border-radius: 5.995vw;
      padding: 1.439vw;
      margin-right: 0.959vw;
      margin-top: 0.48vw;
    }

    ${media.mobile} {
      width: 9.6vw;
      height: 9.6vw;
      border: 1.067vw solid ${colors.primaryOrange};
      border-radius: 13.333vw;
      padding: 3.2vw;
      margin-right: 2.133vw;
      margin-top: 1.067vw;
    }
  }
`

const LI = styled.li.attrs(props => ({}))`
  ${text.bodyMd};
`
